import { kv } from '@vercel/kv';
import { clenseMapdata } from '../map/maps';
import { addUrlToSitemap } from '../sitemapKeys';
// import logger from '../logger';
// import { createClient } from '../supabaseSetup/server';
import { createClient } from '../supabaseSetup/client';
import { slugify } from '../map/slugify';
import snakecaseKeys from 'snakecase-keys';
import { Pass2LearningPath, CareerMap, CareerMapDB } from '../../typesV2';

const slugifyAllSubTopics = (topics: Pass2LearningPath) => {
  return topics.map((topic) => ({
    ...topic,
    sections: topic?.sections?.map((subTopic) => ({
      ...subTopic,
      slug: slugify(subTopic.subTopicTitle),
    })),  
    options: topic?.options?.map((option) => ({
      ...option,
      slug: slugify(option.optionTitle),
    })),
    sideQuests: topic?.sideQuests?.map((sideQuest) => ({
      ...sideQuest,
      slug: slugify(sideQuest.sideQuestTitle),
    })),
  }));
};

type SaveMapProps = {
  mapSlug: string;
  jobTitle: string;
  overview: string;
  learningPath: Pass2LearningPath;
  whatsNext?: string;
  slugifySubtopics?: boolean;
};

export const saveMap =
  async ({
    mapSlug,
    jobTitle,
    overview,
    learningPath,
    whatsNext,
    slugifySubtopics = true,
  }: SaveMapProps): Promise<CareerMapDB> => {
    const supabaseServerClient = await createClient();

    // SLUGIFY SUBTOPICS
    const slugifiedTopicList = slugifySubtopics ? slugifyAllSubTopics(learningPath) : learningPath;

    const mapWithSlugifiedSubtopics: CareerMapDB = {
      // ...snakecaseKeys(clenseMapdata(existingMap), { deep: false }),
      slug: mapSlug,
      job_title: jobTitle,
      job_description: overview,
      topic_list: slugifiedTopicList,
      whats_next: whatsNext,
      updated_at: new Date().toISOString().slice(0, 19).replace('T', ' '),
    };


    let userData;
    // CHECK IF USER IS LOGGED IN
    try {
      const { data, error: userError } =
        await supabaseServerClient.auth.getUser();

      userData = data;
    } catch (error) {
      // logger.error('ERROR GETTING USER DATA', { error });
    }

    // SAVE MAP TO USER DB if user is logged in
    if (userData?.user) {
      try {
        const { error: saveMapError, data: saveMapData }: any =
          await supabaseServerClient
            .from('maps')
            .insert([
              {
                ...mapWithSlugifiedSubtopics,
                user_id: userData.user.id,
              },
            ])
            .select('*');
        if (saveMapError) {
          throw saveMapError;
        }
      } catch (error) {
        console.log('🚀 ~ error saving map', error);
        throw error;
      }
    }

    return mapWithSlugifiedSubtopics;
  };
